export default __webpack_public_path__ + "9624f1e86bf7b4498b74582b1c9dbc3f.png";